import React from "react";
export const SmsTemplateDetailContext = React.createContext(null);
export const useSmsTemplateDetailContext = () => {
  const context = React.useContext(SmsTemplateDetailContext);
  if (!context) throw new Error("SMS Template Detail Context not provided!");
  return context;
};
